import React, { Component } from "react";
import { Table, Row, Col, Icon } from "antd";
import moment from "moment";

class Page extends Component {
  state = {
    isFold: true,
  };

 columns = () => {
    return [
      {
        title: "日期",
        dataIndex: "date",
        render: text => (
          <span>
            {text ? moment.unix(text / 1000).format("YYYY-MM-DD HH:mm") : null}
          </span>
        ),
      },
      {
        title: "操作内容",
        dataIndex: "operating",
      },
      {
        title: "处理意见",
        dataIndex: "refuse",
      },
    ];
  }

  handleFold = flag => {
    this.setState({
      isFold: !!flag,
    });
  };

  render() {
    const { dataSource } = this.props;
    const { isFold } = this.state;
    let list = [];
    if (dataSource.length > 1) {
      list = isFold ? [dataSource[0]] : dataSource;
    } else {
      list = dataSource;
    }
    const style = {
      width: "60px",
      height: "30px",
      borderRadius: "999px",
      textAlign: "center",
      lineHeight: "26px",
      fontSize: "16px",
      marginRight: "10px",
      marginTop: "12px",
      color: "#999",
    };
    return (
      <Row type="flex">
        {dataSource.length > 1 ? (
          <Col style={style}>
            {isFold ? (
              <div
                onClick={() => this.handleFold(false)}
                style={{ cursor: "pointer" }}
              >
                展开
                <Icon type="right" />
              </div>
            ) : null}
            {!isFold ? (
              <div
                onClick={() => this.handleFold(true)}
                style={{ cursor: "pointer" }}
              >
                收起
                <Icon type="down" />
              </div>
            ) : null}
          </Col>
        ) : null}

        <Col style={{ flex: 1 }}>
          <Table
            columns={this.columns()}
            rowKey="uuid"
            pagination={false}
            dataSource={list}
          />
        </Col>
      </Row>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/comm/workflow/ProcessHistory.js